module.exports = __webpack_public_path__ + "img/login1.ca2b2bf8.png";